import { all } from 'redux-saga/effects';

import verifyAccountSaga from './verifyAccount-saga';
import createAccountSaga from './createAccount-saga';
import createPatientSaga from './createPatient-saga';
import patientKinSaga from './patientKin-saga';
import caseSaga from './case-saga';

export default function* rootSaga() {
  yield all([
    verifyAccountSaga(),
    createAccountSaga(),
    createPatientSaga(),
    patientKinSaga(),
    caseSaga(),
  ]);
}
